module.exports = __webpack_public_path__ + "img/pro_thirteen_11.0614f49f.jpg";